<template>
  <div class="relative">
    <z-loading :active="isLoading" :is-full-page="false" />
    <validation-observer ref="observer" tag="div">
      <div v-if="showNextButton">
        <div class="text-black">{{ $t('CivilID') }}</div>
        <div class="font-bold text-black">{{ civilId }}</div>
        <br />
      </div>

      <z-input-with-validation
        v-else
        :key="$i18n.locale"
        rules="required|kuwait_civil_id|civil_id_over_18"
        v-model="civilId"
        class="text-start"
        :label="$t('CivilID')"
        input-classes="font-bold text-black">
      </z-input-with-validation>

      <div v-if="showNextButton">
        <div class="font-bold text-black">
          {{ $t('AfterSuccessSubmitText') }}
        </div>
        <z-button class="w-full mt-4" @click="onClickNext">
          {{ $t('Next') }}
        </z-button>
      </div>
      <z-button
        v-else
        :disabled="!civilId || civilId.length !== 12"
        pattern="[0-9]*"
        @click="submitId"
        class="w-full mt-4">
        {{ $t('Submit') }}
      </z-button>
    </validation-observer>

    <div
      v-if="$store.state.isMock"
      class="mt-32 p-3 rounded-md bg-gray-100 text-sm">
      <p class="mb-3 font-bold">Mock POST /paci-update/auth</p>

      <div class="flex items-center space-x-3">
        <input
          type="radio"
          :value="null"
          v-model="mockDebugUpdatePaci"
          name="mockDebugUpdatePaci" />
        <span class="text-red-600">No Mock</span>
      </div>

      <div class="flex items-center space-x-3">
        <input
          type="radio"
          value="Success"
          v-model="mockDebugUpdatePaci"
          name="mockDebugUpdatePaci" />
        <span>Mock Success ("status": "Success")</span>
      </div>

      <div class="flex items-center space-x-3">
        <input
          type="radio"
          value="No Identity/Device Found "
          v-model="mockDebugUpdatePaci"
          name="mockDebugUpdatePaci" />
        <span>Mock Fail (status: "No Identity/Device Found ")</span>
      </div>

      <div class="flex items-center space-x-3">
        <input
          type="radio"
          value="User is not eligible"
          v-model="mockDebugUpdatePaci"
          name="mockDebugUpdatePaci" />
        <span>Mock Fail (status: "User is not eligible")</span>
      </div>

      <div class="flex items-center space-x-3">
        <input
          type="radio"
          value="Bad Request"
          v-model="mockDebugUpdatePaci"
          name="mockDebugUpdatePaci" />
        <span>Mock Fail (status: "Bad Request")</span>
      </div>

      <!--            <label class='flex items-center space-x-4'>-->
      <!--        <input type='radio' name='mockDebugUpdatePaci' />-->
      <!--        <span>Mock Success (status: "No Identity/Device Found ")</span>-->
      <!--      </label>-->
    </div>
  </div>
</template>

<script>
import ZInputWithValidation from '@/zain-component-library/src/lib-components/ZInputWithValidation'
import ZButton from '@/zain-component-library/src/lib-components/ZButton'
import { ValidationObserver } from 'vee-validate'
import ZLoading from '@/zain-component-library/src/lib-components/ZLoading'
// import api from '@/api'

export default {
  name: 'UpdateForm',
  components: { ZLoading, ZButton, ZInputWithValidation, ValidationObserver },
  data() {
    return {
      civilId: null,
      mockDebugUpdatePaci: 'Success',
      isLoading: false,
      showNextButton: false,
      response: {}
    }
  },
  methods: {
    async submitId() {
      let isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }

      try {
        this.isLoading = true
        if (this.$store.state.isMock) {
          let response
          switch (this.mockDebugUpdatePaci) {
            case 'Success':
              response = {
                isSuccess: true,
                result: {
                  status: this.mockDebugUpdatePaci,
                  request_id: '15666d3c-c5fa-4413-9653-cfc5361d7293'
                }
              }

              break
            case 'User is not eligible':
            case 'No Identity/Device Found ':
            case 'Bad Request':
              response = {
                isSuccess: false,
                result: {
                  status: this.mockDebugUpdatePaci
                }
              }
              break
          }
          // artificial delay
          await new Promise((resolve) => setTimeout(resolve, 1000))

          await this.handleSubmitResponse(response, true)
          return
        }

        await this.$store.dispatch('submitInfoUpdate', {
          civilId: this.civilId
        })

        if (this.$store.state.preUpdateIdInfoResult)
          await this.handleSubmitResponse(
            this.$store.state.preUpdateIdInfoResult ??
              this.$store.state.updateIdInfoResult
          )
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async onClickNext() {
      // set state variable to change view state (setting again for the mocks)
      // console.log(this.response)
      this.$store.state.updateIdInfoResult = this.response
      await this.$store.dispatch(
        'setPaciRequestId',
        this.response?.result?.request_id
      )
    },
    async handleSubmitResponse(response, isMock) {
      if (response?.isSuccess || isMock) {
        this.response = response
        this.$store.state.navText = ''
        this.showNextButton = true
      } else {
        // show error message instead of modal. hacking my way throw the child components without changing anything in zcl
        this.$refs.observer.$data.errors[this.$t('CivilID')][0] = this.$t(
          'CivilIDErrorMessage'
        )
        this.$refs.observer.$data.fields[this.$t('CivilID')].valid = false
        this.$refs.observer.$data.fields[this.$t('CivilID')].invalid = true
        this.$refs.observer.$children[0].$children[0].$data.flags.valid = false
      }

      try {
        await this.$store.dispatch('sendAnalyticsEvent', {
          eventAction: 'kyc-submit-paci',
          eventCategory: 'kyc-page',
          eventLabel: response?.result?.status || 'N/A'
        })
        // eslint-disable-next-line no-empty
      } catch (e) {}
    }
  },
  mounted() {
    this.$store.state.navText = 'InformationNeed'
  }
}
</script>

<style>
label.text-sm {
  color: black;
}
</style>
